var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"weight-application"},[_c('weight-upload',{on:{"addWeight":_vm.addWeight}}),_vm._v(" "),_c('weight-list',{attrs:{"id":"weightList","weightList":_vm.weightList},on:{"deleteWeight":_vm.deleteWeight}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58d0b7c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeightApplication.vue
// module id = 258
// module chunks = 1